import { render, staticRenderFns } from "./myVideo.vue?vue&type=template&id=11882782&scoped=true"
import script from "./myVideo.vue?vue&type=script&lang=js"
export * from "./myVideo.vue?vue&type=script&lang=js"
import style0 from "./myVideo.vue?vue&type=style&index=0&id=11882782&prod&lang=scss&scoped=true"
import style1 from "./myVideo.vue?vue&type=style&index=1&id=11882782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11882782",
  null
  
)

export default component.exports